export enum NotificationType {
    Task = 1
  }